<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Receber Contas selecionadas</h2>
    <button mat-icon-button (click)="fechar()" [disabled]="isSaving">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content" [formGroup]="form">
    <app-alert-card type="warning" icon="info" class="mb-3 d-block">
      Ao trocar a <strong>Conta de Recebimento</strong> ou a <strong>Data</strong>, os campos de
      <strong>Multa</strong>, <strong>Juros</strong> e <strong>Valor Recebido</strong> são recalculados
      e sobrescrevem valores já digitados manualmente.
    </app-alert-card>

    <!-- Header inputs -->
    <div class="row header-fields">
      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          [control]="$any(form.get('idContaFinanceira'))"
          [offlineList]="data.listaContasFinanceiras"
          label="Conta de Recebimento"
          idField="idContaFinanceira"
          nameField="descricao"
          [isOptional]="false"
          hint="Selecione a conta de Recebimento...">
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data</mat-label>
          <input matInput [matDatepicker]="pickerData" formControlName="dataRecebimento" />
          <mat-datepicker-toggle matSuffix [for]="pickerData"></mat-datepicker-toggle>
          <mat-datepicker #pickerData></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-12 mt-3">
        <span class="editor-label">Observações</span>
        <div class="editor-container">
          <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
          <ngx-editor
            [editor]="editor"
            formControlName="observacoesHtml"
            placeholder="Digite as observações do Recebimento..."></ngx-editor>
        </div>
      </div>
    </div>

    <div class="section-container" id="dados-parcela">
      <div class="section-title">
        <mat-icon>receipt_long</mat-icon>
        <span>Parcelas</span>
      </div>

      @if (isLoading) {
        <div class="d-flex justify-content-center p-4">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      <!-- Cards -->
      @if (!isLoading) {
        <div class="cards-container" formArrayName="parcelas">
          @for (item of parcelasFormArray.controls; track item; let i = $index) {
            <div class="document-card" [formGroupName]="i">
              <div class="card-header-info">
                <div class="info-group">
                  <small>Cliente</small>
                  <span class="bold-text text-truncate">{{ item.get('cliente')?.value || '-' }}</span>
                </div>
                <div class="info-group">
                  <small>N° DOC</small>
                  <span class="bold-text">{{ item.get('numeroDocumento')?.value || '-' }}</span>
                </div>
                <div class="info-group">
                  <small>VENCIMENTO</small>
                  <span class="bold-text">{{ item.get('vencimento')?.value | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="info-group text-end ms-auto">
                  <small>VALOR ORIGINAL</small>
                  <span class="bold-text valor-original">{{
                    item.get('valorOriginal')?.value | abnt: 'preco': 2
                  }}</span>
                </div>
                <div class="info-group text-end ms-3">
                  <small>VALOR EM ABERTO</small>
                  <span class="bold-text valor-original">{{
                    item.get('valorAReceber')?.value | abnt: 'preco': 2
                  }}</span>
                </div>
              </div>
              <div class="card-inputs mt-3 row">
                <div class="col-12 col-md-4 col-lg-3">
                  <app-select-pesquisavel
                    [control]="$any(item.get('idCategoriaFinanceira'))"
                    [offlineList]="data.listaCategorias"
                    label="Categoria"
                    idField="idCategoriaFinanceira"
                    nameField="descricao"
                    [isOptional]="false"
                    hint="Venda de Mercadorias">
                  </app-select-pesquisavel>
                </div>
                <div class="col-6 col-md-4 col-lg-2">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Multa</mat-label>
                    <input
                      matInput
                      formControlName="valorMulta"
                      [currencyMask]="currencyMask"
                      (ngModelChange)="calcularTotalCard(i)" />
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-4 col-lg-2">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Juros</mat-label>
                    <input
                      matInput
                      formControlName="valorJuros"
                      [currencyMask]="currencyMask"
                      (ngModelChange)="calcularTotalCard(i)" />
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-4 col-lg-2">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Desconto</mat-label>
                    <input
                      matInput
                      formControlName="valorDesconto"
                      [currencyMask]="currencyMask"
                      (ngModelChange)="calcularTotalCard(i)" />
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-4 col-lg-2">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Acréscimo</mat-label>
                    <input
                      matInput
                      formControlName="valorAcrescimo"
                      [currencyMask]="currencyMask"
                      (ngModelChange)="calcularTotalCard(i)" />
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-4 col-lg-2 ms-auto ms-lg-0">
                  <mat-form-field appearance="outline" class="w-100 highlight-field">
                    <mat-label>Valor Recebido</mat-label>
                    <input matInput formControlName="valorRecebido" [currencyMask]="currencyMask" />
                    @if (item.get('valorRecebido')?.invalid) {
                      <mat-error>Inválido</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="dialog-footer flex-wrap gap-3">
    <div class="footer-total d-none d-md-flex">
      <small>Total</small>
      <span class="total-value">{{ totalRecebido | abnt: 'preco': 2 }}</span>
    </div>

    <div
      class="footer-actions d-flex w-100 justify-content-end"
      style="max-width: fit-content; margin-left: auto">
      <button
        mat-stroked-button
        class="btn-secondary flex-grow-1 flex-md-grow-0"
        (click)="fechar()"
        [disabled]="isSaving">
        Cancelar
      </button>
      <button
        mat-flat-button
        class="btn-primary flex-grow-1 flex-md-grow-0"
        (click)="salvar()"
        [disabled]="isSaving">
        @if (!isSaving) {
          <span>Receber Contas</span>
        }
        @if (isSaving) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>
